import { createPerfilApiClient } from './perfilApiClient';

/**
 * Términos y Condiciones — Service
 *
 * Guarda la aceptación de términos y condiciones del abonado en backend.
 * Usa `createPerfilApiClient()` para autenticación y gestión de cabeceras.
 *
 * Endpoint ABONOS: POST /f/abonados/compra/{session_id}/terminos-y-condiciones
 * (mapeado en `api-routes.js` como `front.abonados.compra.terminos-y-condiciones`
 * y despachado por `FRONT_ABONADOS_COMPRA_TERMINOS_Y_CONDICIONES`).
 *
 * El `session_id` se pasa tanto en la URL (path param) como en el body (en
 * `filters` y a nivel raíz) para máxima compatibilidad con el payload
 * legacy que espera el backend (ver `ResumenCompraComponent.vue` y
 * `RenovarAbonoLfp.vue`).
 *
 * Los errores NO se capturan aquí; se propagan al composable que los convierte
 * con `toError()` para exponer `loading/error` consistentes.
 */

export default {
    /**
     * Guarda la aceptación de términos y condiciones del abonado.
     *
     * @param {Object}  params
     * @param {boolean} params.privacidad       — Aceptación de política de privacidad
     * @param {boolean} params.condiciones      — Aceptación de condiciones generales
     * @param {boolean} params.comunicaciones   — Aceptación de comunicaciones comerciales
     * @param {string}  params.session_id       — ID de sesión del bloqueo activo (obligatorio)
     * @returns {Promise<Object>}  Respuesta del backend
     * @throws {Error} Si falta `session_id` (no se puede construir la URL).
     */
    async guardarTerminos({ privacidad, condiciones, comunicaciones, session_id }) {
        if (!session_id) {
            throw new Error('[terminosService.guardarTerminos] session_id is required');
        }

        const client = createPerfilApiClient();
        const apiKey = localStorage.getItem('token');
        const sid = String(session_id);

        const response = await client.post(
            `/f/abonados/compra/${sid}/terminos-y-condiciones`,
            {
                filters: {
                    session_id: sid,
                    privacidad,
                    condiciones,
                    comunicaciones,
                },
                session_id: sid,
                privacidad,
                condiciones,
                comunicaciones,
            },
            {
                params: { api_key: apiKey },
            }
        );
        return response.data;
    },
};
